import React from 'react';
import Locale from '../locales/en/landingPage';
import TitleSVG from '../images/blueprint-title.svg';
import PillarTitlesSVG from '../images/pillar-titles-new.svg';
import Background from '../images/pillar-graphic.svg';

const LandingPage = () => (
  <div id="top" className="landing-page">
    <img src={TitleSVG} alt="Equitable Homeownership Blueprint" />
    <div className="mobile-image">
      <img src={Background} alt="House background" />
    </div>
    <img
      className="pillars"
      src={PillarTitlesSVG}
      alt="Blueprint pillar titles"
    />
    <div className="mobile-pillars">
      {Locale.pillars.map((pillar) => <p>{pillar}</p>)}
    </div>
  </div>
);

export default LandingPage;
